import { getToday } from '~/astra'
import { type HospitalConfigPractitioner, isPractitionerActive, useAllPractitionersForHospitalConfig } from '~/storm'
import { getPractitionerFullname } from '~/utils/dips'

import { DipsSurgeonTableViewModel, PractitionerTableViewModel } from './SurgeonsTable'
import { useDipsSurgeons } from './useDipsSurgeons'

export const useSurgeonTableViewModel = ({ search }: { search?: string }) => {
    const simpleMatch = (value: string | null) =>
        value && search && search.length > 0 ? value.trim().toLowerCase().includes(search.trim().toLowerCase()) : true

    const allPractitioners = useAllPractitionersForHospitalConfig().filter(p => simpleMatch(p.short_name) || simpleMatch(getPractitionerFullname(p)))
    const dipsSurgeons = useDipsSurgeons().filter(s => simpleMatch(s.shortName) || simpleMatch(s.name))

    const today = getToday()

    const dipsIdToPractitioner = new Map<number, HospitalConfigPractitioner>()

    const practitioners: PractitionerTableViewModel[] = allPractitioners
        .map(practitioner => {
            if (practitioner.dipsResource?.id !== undefined) {
                dipsIdToPractitioner.set(practitioner.dipsResource.id, practitioner)
            }
            return {
                ...practitioner,
                status: isPractitionerActive(practitioner, today, today) ? 'active' : 'inactive',
            } as const
        })
        .toSorted((a, b) => getPractitionerFullname(a).localeCompare(getPractitionerFullname(b)))

    const dipsSurgeonWithUpdates: DipsSurgeonTableViewModel[] = dipsSurgeons
        .filter(dipsResource => !dipsIdToPractitioner.has(dipsResource.id) && dipsResource.inUse)
        .map(dipsResource => ({
            ...dipsResource,
            status: 'new',
        }))

    return {
        activePractitioners: practitioners.filter(p => p.status === 'active'),
        inactivePractitioners: practitioners.filter(p => p.status === 'inactive'),
        dipsSurgeons: dipsSurgeonWithUpdates,
    }
}
